<template lang="pug">
UniversalLink(
  link='PROTEX'
  element='button'
  class='flex items-center justify-center font-bold py-2 px-6 mb-2 lg:mr-2 lg:mb-0 border rounded text-inherit'
  @click='$uiEvents.$emit("BuilderButtonClicked", data)'
)
  img(src='/images/3dSpin.svg' alt='' class='w-6 h-4 mr-2')
  | See it on your {{ fitmentStore.model }}
</template>

<script setup lang="ts">
const { $uiEvents } = useNuxtApp()
const fitmentStore = useFitmentStore()

const { data } = defineProps<{
  data: ProductLine
}>()

onMounted(() => {
  emitBuilderButtonViewed()
})

watch(fitmentStore.$state, async () => {
  emitBuilderButtonViewed()
})

function emitBuilderButtonViewed() {
  $uiEvents.$emit('BuilderButtonViewed', data)
}
</script>
